export enum BaseMap {
    OSM_Street = 'Open Street Maps',
    OSM_Elevation = 'Open Elevation',
    GSM_Satellite = 'Google Satellite',
    GSM_Street = 'Google Street',
    GSM_Hybrid = 'Google Hybrid',
    Empty_Black = 'Empty (Black)',
    Empty_White = 'Empty (White)',
}
